import { CategoryOverviewPageLog as CategoryOverviewPageCommonLog } from '../../protobuf-log/home-common-txtpb';

import type { CategoryWidgetActionMeta } from '@yanolja-org/core-ui';

function isItemClick(meta: CategoryWidgetActionMeta): boolean {
  return Boolean(meta.serverLogMeta?.categoryAreaDetailTitle);
}

export const categoryLog = {
  /** 카테고리 오버레이 노출 (CategoryDropdown 열림) */
  async view(): Promise<void> {
    await CategoryOverviewPageCommonLog.Unspecified.view();
  },

  /**
   * 카테고리 클릭. `meta.serverLogMeta.categoryAreaDetailTitle` 존재 여부로
   * 대분류(GroupTitle) / 중분류(Item) 자동 분기.
   */
  async click(meta: CategoryWidgetActionMeta): Promise<void> {
    const logMeta = meta.serverLogMeta;
    if (isItemClick(meta)) {
      await CategoryOverviewPageCommonLog.CategoryTitleButtonSub.click({ logMeta });
      return;
    }
    await CategoryOverviewPageCommonLog.ButtonCategoryTitle.click({ logMeta });
  },
};

/**
 * CategoryDropdown 이 열릴 때 호출하는 view-impression log.
 * `<CategoryDropdown onOpenChange>` 의 `open === true` 분기에서 사용.
 *
 * 호스트가 `categoryLog` object 자체를 import 하지 않고 named function 으로만 노출 —
 * adapter 의 logging 구현 디테일을 호스트에 숨김.
 */
export const trackCategoryView = () => categoryLog.view();
